import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { KioskOwnerCap } from '@mysten/kiosk';
import { formatAddress } from '@mysten/sui.js/utils';
import classNames from 'classnames';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/24/solid';

export function KioskSelector({
  caps,
  selected,
  setSelected,
}: {
  caps: KioskOwnerCap[];
  selected: KioskOwnerCap;
  setSelected: (item: KioskOwnerCap) => void;
}) {
  return (
    <div className="max-w-[175px] z-50 relative my-3">
      <Listbox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <label className="font-semibold text-xs">Select a kiosk:</label>
          <Listbox.Button
            className="relative w-full text-left app-dropdown-button"
          >
            <span className="block truncate">
              {formatAddress(selected.kioskId)}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
              <ChevronUpDownIcon
                className="size-6 text-white-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options
              className="absolute mt-1 max-h-60 w-full overflow-y-auto overflow-x-hidden
              bg-primary
             ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
              {caps.map(cap => (
                <Listbox.Option
                  key={cap.objectId}
                  className={({ active, selected }) =>
                    classNames(
                      selected || active
                        ? 'border-primary text-white'
                        : 'text-white',
                      'app-loader-button relative select-none cursor-pointer py-2 my-1 px-4',
                    )
                  }
                  value={cap}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
                      >
                        {formatAddress(cap.kioskId)}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 right-3 flex items-center text-white">
                          <CheckIcon className="size-4" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
